module.exports = __webpack_public_path__ + "static/img/case_banner_bg.f23cbcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_bg.png
// module id = r2EF
// module chunks = 34